export const enum PropertySavedIdbStatechartEvent {
  synced = 'synced',
  sync = 'sync',
  loadAllSuccess = 'load-all-success',
  loadAll = 'load-all',
}
